module.exports = __webpack_public_path__ + "static/Marianos_pin_hover-87ebe3996f74953eea89483668ce6136.png";